@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.active::after {
  content: "";
  background-color:  hevo-toolkit-variables.$primary;
  border-radius: 50%;
  position: absolute;
  width: 8px;
  height: 8px;
  right: 4px;
  top: 6px;
}
